export default "__VITE_ASSET__D_ivh_S$__"